export const capitalizeFirstLetter = (word) => `${word[0].toUpperCase()}${word.slice(1)}`;

/**
 * Returns the human-readable display name for a product/plan.
 *
 * New product/plan names embed operational metadata after a single pipe, e.g.
 * "Alexandrite Lite | BVT 202602198819 [C0A2E0]". 
 * Only d segment to  left of the pipe is shown to enrollees.  -> "Alexandrite Lite"
 *
 * Legacy names (no pipe) are returned unchanged. Non-string values
 */
export const formatProductName = (name) => {
  if (typeof name !== "string") return name;
  return name.split("|")[0].trim();
};

/**
 * The submit (POST /enrollees/profile) returns HTTP 423 Locked with a clear
 * { message } body when the enrollee is inside the freeze window.
 * the UI uses it to surface the backend's message directly
 */
export const isInvoiceAheadFreeze = (error) => {
  const status = error?.response?.status ?? error?.status;
  return status === 423;
};
